import { ReactElement } from 'react'

import Icon from '@ant-design/icons'

import { IconProps } from '../localTypes'

import ChevronIconSvg from './ChevronIconSvg'

const ChevronIcon = (props: IconProps): ReactElement => (
    <Icon component={ChevronIconSvg} {...props} />
)

export default ChevronIcon
